import { IconVideoCamera, IconMapMarkerFilled } from '../../../../../../../../shared/Icon'
import {
  setScheduleTourIsInPerson,
  selectScheduleTourIsInPerson
} from '../../../../../../../../../store/slices/scheduleTour'
import classnames from 'classnames'
import { useSelector, useDispatch } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Button } from '../../../../../../../..'

import styles from './WhereStepBody.module.scss'

const WhereStepBody = () => {
  const dispatch = useDispatch()
  const inPerson = useSelector(selectScheduleTourIsInPerson)

  return (
    <>
      <Button
        className={classnames(styles.locationBtn, inPerson && styles.selected)}
        onClick={() => !inPerson && dispatch(setScheduleTourIsInPerson(true))}
        iconStart={IconMapMarkerFilled}
      >
        <FormattedMessage id='ScheduleTour.Location.InPerson' defaultMessage='In Person' />
      </Button>
      <Button
        className={classnames(styles.locationBtn, !inPerson && styles.selected)}
        onClick={() => inPerson && dispatch(setScheduleTourIsInPerson(false))}
        iconStart={IconVideoCamera}
      >
        <FormattedMessage id='ScheduleTour.Location.LiveVideo' defaultMessage='Live Video' />
      </Button>
    </>
  )
}

export default WhereStepBody
